import { ErrorPageSection } from '@gik/core/pages/Error/ErrorPageSection';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { RelatedProductsSection } from '@gik/shop/components/products/RelatedProductsSection/RelatedProductsSection';
import { PageSection } from '@gik/ui/gik/PageSection';
import React from 'react';
import { ProductSectionWithData } from '../../components/products/ProductSection/ProductSectionWithData';

export interface IProductPageProps extends React.HTMLAttributes<HTMLDivElement> {
  productSlug: string;
  inkindRouteId?: string;
}

function ProductPageComp({ className, productSlug, inkindRouteId }: IProductPageProps) {
  const bem = useBemCN('product-page');

  return (
    <div {...bem(null, null, className)}>
      <PageSection defaultPadding>
        <ProductSectionWithData productSlug={productSlug} type="productPage" inkindRouteId={inkindRouteId} />
      </PageSection>

      <RelatedProductsSection
        {...bem('related-products')}
        copy={'Others also gifted...'}
        variant={'transparent'}
        searchParams={{
          similarTo: productSlug,
        }}
        headingLevel={2}
      />
    </div>
  );
}

export const ProductPage = withComponentErrorBoundary(ProductPageComp, { ErrorFallback: ErrorPageSection });
